module.exports = __webpack_public_path__ + "img/bgImg1.5aad4236.png";